import { render, staticRenderFns } from "./LogosEdit.vue?vue&type=template&id=4b58d531"
import script from "./LogosEdit.vue?vue&type=script&lang=js"
export * from "./LogosEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports